import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { hasAccess } from '../../utils/permissionHelper';
import { MdFeedback } from 'react-icons/md';

const Sidebar = () => {
  const location = useLocation();
  const isActive = path => location.pathname === path;
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <div data-simplebar className="h-100">
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title">Menu</li>

          {hasAccess(user, "Dashboard") && (
            <li className={isActive("/dashboard") ? 'mm-active' : ''}>
              <NavLink to="/dashboard" className="waves-effect">
                <i className="mdi mdi-view-dashboard"></i>
                <span>Dashboard</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "Member") && (
            <li className={isActive("/user") ? 'mm-active' : ''}>
              <NavLink to="/user" className="waves-effect">
                <i className="fas fa-users"></i>
                <span className="ms-2">Member</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "Family") && (
            <li className={isActive("/family") ? 'mm-active' : ''}>
              <NavLink to="/family" className="waves-effect">
                <i className="fas fa-user-friends"></i>
                <span className="ms-2">Family</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "Guest") && (
            <li className={isActive("/guest") ? 'mm-active' : ''}>
              <NavLink to="/guest" className="waves-effect">
                <i className="fas fa-user-clock"></i>
                <span className="ms-2">Guest</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "Event") && (
            <li className={isActive("/event") ? 'mm-active' : ''}>
              <NavLink to="/event" className="waves-effect">
                <i className="fas fa-calendar-alt"></i>
                <span className="ms-2">Event</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "CoreTeam") && (
            <li className={isActive("/coreTeam") ? 'mm-active' : ''}>
              <NavLink to="/coreTeam" className="waves-effect">
                <i className="fas fa-users-cog"></i>
                <span className="ms-2">Core Team</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "Contribution Team") && (
            <li className={isActive("/contributionTeam") ? 'mm-active' : ''}>
              <NavLink to="/contributionTeam" className="waves-effect">
                <i className="fas fa-hands-helping"></i>
                <span className="ms-2">Contribution Team</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "PartnerRequest") && (
            <li className={isActive("/partnerRequest") ? 'mm-active' : ''}>
              <NavLink to="/partnerRequest" className="waves-effect">
                <i className="fas fa-handshake"></i>
                <span className="ms-2">PartnerRequest</span>
              </NavLink>
            </li>
          )}

         {/*  {hasAccess(user, "Fees") && (
                     <li className={isActive("/fees") ? 'mm-active' : ''}>
                       <NavLink to="/fees" className="waves-effect">
                         <i className="fas fa-wallet"></i>
                         <span className="ms-2">Fees</span>
                       </NavLink>
                     </li>
                   )} */}

          {hasAccess(user, "masterSettings") && (
            <li className={isActive("/setting") ? 'mm-active' : ''}>
              <NavLink to="/setting" className="waves-effect">
                <i className="dripicons-gear"></i>
                <span>Master Settings</span>
              </NavLink>
            </li>
          )}
           {hasAccess(user, "role") && (
            <li className={isActive("/role") ? 'mm-active' : ''}>
              <NavLink to="/role" className="waves-effect">
                <i className="fas fa-user-shield"></i>
                <span>Roles</span>
              </NavLink>
            </li>
          )}
          {hasAccess(user, "responsibility") && (
            <li className={isActive("/responsibility") ? 'mm-active' : ''}>
              <NavLink to="/responsibility" className="waves-effect">
                <i className="fas fa-tasks"></i>
                <span>Responsibility</span>
              </NavLink>
            </li>
          )}
          {hasAccess(user, "C2C") && (
            <li className={isActive("/report") ? 'mm-active' : ''}>
              <NavLink to="/report" className="waves-effect">
                <i className="fas fa-file-alt"></i>
                <span>Activity</span>
              </NavLink>
            </li>
          )}

          {hasAccess(user, "mobilesettings") && (
            <li className={isActive("/mobileSetting") ? 'mm-active' : ''}>
              <NavLink to="/mobileSetting" className="waves-effect">
                <i className="fas fa-mobile-alt"></i>
                <span>Mobile Settings</span>
              </NavLink>
            </li>
          )}
          
            {hasAccess(user, "Pricingplans") && (
                                 <li className={isActive("/pricingPlans") ? 'mm-active' : ''}>
                                   <NavLink to="/pricingPlans" className={({ isActive }) =>
                                     `waves-effect ${isActive ? 'active' : ''}`
                                   }>
                                     <i className="fas fa-credit-card"></i>
                                     <span>Subscription</span>
                                   </NavLink>
                                 </li>
                               )}  
                               {hasAccess(user, "FeedbackReview") && (
                                 <li className={isActive("/feedbackReview") ? 'mm-active' : ''}>
                                   <NavLink to="/feedbackReview" className={({ isActive }) =>
                                     `waves-effect ${isActive ? 'active' : ''}`
                                   }>
                                     <i><MdFeedback /></i>
                                     <span>Feedback & Review</span>
                                   </NavLink>
                                 </li>
                               )}  
                               {hasAccess(user, "bloodgroupRequest") && (
                                 <li className={isActive("/bloodgroupRequest") ? 'mm-active' : ''}>
                                   <NavLink to="/bloodgroupRequest" className={({ isActive }) =>
                                     `waves-effect ${isActive ? 'active' : ''}`
                                   }>
                                     <i><MdFeedback /></i>
                                     <span>Bloodgroup & Request</span>
                                   </NavLink>
                                 </li>
                               )}  
                    {/* {hasAccess(user, "Notification") && (
                                                               <li className={isActive("/notification") ? 'mm-active' : ''}>
                                                                 <NavLink to="/notification" className={({ isActive }) =>
                                                                   `waves-effect ${isActive ? 'active' : ''}`
                                                                 }>
                                                                   <i className="fas fa-bell"></i>
                                                                   <span>Logs</span>
                                                                 </NavLink>
                                                               </li>
                                                             )}  */} 

        </ul>
      </div>
    </div>
  );
};

export default Sidebar;


        